import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { WorkingTimeState } from './states'

const WorkingTime: Module<WorkingTimeState, State> = {
  state: new WorkingTimeState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default WorkingTime
